import { Switch } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { borderRadius, boxShadows, palette } from '../../../assets/styles/themes/tokens';
import grid4 from '../../../assets/lernsets/icons/grid4.svg?raw';
import fullScreen from '../../../assets/lernsets/icons/full-screen.svg?raw';

const prepareSvgWithColor = (svg: string, color: string) => {
  const colorizedSvg = svg.replace(/currentColor/g, color);
  return colorizedSvg;
};

const activeGrid4 = prepareSvgWithColor(grid4, palette.text.primary);
const activeFullScreen = prepareSvgWithColor(fullScreen, palette.text.primary);
const passiveGrid4 = prepareSvgWithColor(grid4, palette.text.disabled);
const passiveFullScreen = prepareSvgWithColor(fullScreen, palette.text.disabled);

interface SwitchModeProps {
  checked?: boolean;
  onChange: (isFullScreen: boolean) => void;
}

const SwitchMode : React.FC<SwitchModeProps> = (props) => {
  const { t } = useTranslation();
  const { checked = false, onChange } = props;
  
  return <Switch
    checked={checked}
    onChange={(_event, isChecked) => {
      onChange(isChecked);
    }}
    inputProps={{
      'aria-label': checked ? t('Close fullscreen') : t('Open fullscreen'),
    }}
    sx={{
      alignSelf: 'stretch',
      width: '68px',
      height: '32px',
      padding: 0,
      '& .MuiSwitch-track': {
        borderRadius: borderRadius.xs,
        background: palette.action.disabledBackground,
        '&::before, &::after': {
          content: '""',
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          width: 16,
          height: 16,
        },
        '&::before': {
          backgroundImage: `url('data:image/svg+xml;utf8,${encodeURIComponent(passiveGrid4)}')`,
          left: 12,
        },
        '&::after': {
          backgroundImage: `url('data:image/svg+xml;utf8,${encodeURIComponent(passiveFullScreen)}')`,
          right: 12,
        },
      },
      '& .MuiSwitch-thumb': {
        width: '32px',
        height: '30px',
        boxShadow: boxShadows.elevation2,
        borderRadius: borderRadius.xs,
        '&::before': {
          content: '""',
          position: 'absolute',
          width: '100%',
          height: '100%',
          left: 0,
          top: 0,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundImage: `url('data:image/svg+xml;utf8,${encodeURIComponent(activeGrid4)}')`,
        },
      },
      '& .MuiSwitch-switchBase': {
        padding: '1px',
        color: palette.background.paperElevation2,
        boxShadow: boxShadows.elevation2,
        '&.Mui-checked': {
          transform: 'translateX(34px)',
          color: palette.background.paperElevation2,
          '& + .MuiSwitch-track': {
            background: palette.action.disabledBackground,
          },
          '& .MuiSwitch-thumb:before': {
            backgroundImage: `url('data:image/svg+xml;utf8,${encodeURIComponent(activeFullScreen)}')`,
          },
        },
      },
    }} />;
};

export default SwitchMode;
